import { inject, Injectable, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

export type ModalRef = BsModalRef;

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modal = inject(BsModalService);

  public abrirModal(divElement: TemplateRef<any>, size?: 'lg' | 'sm' | 'none') {
    return this.modal.show(divElement, {
      class: `modal-${size || 'lg'}`,
    });
  }
}
